export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  container: "site-nav",
  logo: "nav-logo",
  linkRuns: "nav-link-how-it-runs",
  linkCurriculum: "nav-link-curriculum",
  linkCriteria: "nav-link-who-gets-in",
  linkApply: "nav-link-apply",
  applyBtn: "nav-apply-button",
};

export const HERO = {
  section: "hero-section",
  applyBtn: "hero-apply-button",
  headline: "hero-headline",
};

export const APPLY = {
  ctaPrimary: "cta-apply-primary",
  ctaFinal: "cta-apply-final",
};
